import React, { useState } from 'react';
import './GiftImage.css';

const CATEGORY_META = {
  Kitchen: { tone: 'sunset', icon: '◆' },
  Office: { tone: 'ocean', icon: '◇' },
  'Office Furniture': { tone: 'ocean', icon: '◇' },
  'Living Room': { tone: 'forest', icon: '○' },
  Living: { tone: 'forest', icon: '○' },
  Bedroom: { tone: 'bloom', icon: '✦' },
  Bathroom: { tone: 'sky', icon: '△' },
  default: { tone: 'coral', icon: '★' },
};

function GiftImage({ name, category, imageUrl, className = '', variant = 'card' }) {
  const [failed, setFailed] = useState(false);
  const meta = CATEGORY_META[category] || CATEGORY_META.default;
  const showPlaceholder = !imageUrl || failed;

  if (showPlaceholder) {
    return (
      <div
        className={`gift-image-placeholder gift-image-placeholder--${variant} gift-image-placeholder--${meta.tone} ${className}`}
        aria-label={name}
      >
        <div className="gift-image-placeholder__glow" />
        <div className="gift-image-placeholder__content">
          <span className="gift-image-placeholder__icon">{meta.icon}</span>
          <span className="gift-image-placeholder__name">{name}</span>
          <span className="gift-image-placeholder__category">{category}</span>
        </div>
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={name}
      className={`gift-image ${className}`}
      onError={() => setFailed(true)}
      loading="lazy"
    />
  );
}

export function getConditionBadgeClass(condition) {
  if (condition === 'New') return 'badge-new';
  if (condition === 'Like New') return 'badge-like-new';
  return 'badge-older';
}

export default GiftImage;
